<template>
  <div class="d-flex">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-top="-4"
      offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-tooltip bottom>
          <template v-slot:activator="tooltip">
            <div
              v-bind="tooltip.attrs"
              v-on="tooltip.on">
              <v-text-field
                :value="label"
                :placeholder="$t('administrator.user.field.storage.placeholder')"
                append-icon="mdi-menu-down"
                dense
                outlined
                hide-details
                readonly
                v-bind="attrs"
                v-on="on" />
            </div>
          </template>
          {{ tooltipSelectedItems }}
        </v-tooltip>
      </template>
      <v-card class="px-3">
        <v-text-field
          v-model="query"
          :placeholder="$t('app.form.search.placeholder')"
          class="pa-4 pb-1"
          prepend-inner-icon="mdi-magnify"
          autofocus
          hide-details
          dense
          outlined />
        <v-radio-group
          :value="accessAllStock"
          class="mx-4"
          hide-details
          @change="updateAccessAllStock($event)">
          <v-radio
            :label="$t('administrator.user.field.storage.selectAll')"
            :value="true" />
          <v-radio
            :label="$t('administrator.user.field.storage.selection')"
            :value="false" />
        </v-radio-group>
        <v-list-item class="px-7">
          <v-list-item-content class="pa-0 mb-3">
            <v-virtual-scroll
              :items="selectItems"
              height="180"
              item-height="36">
              <template v-slot:default="{ item }">
                <v-list-item>
                  <v-checkbox
                    :key="`checkbox-item-${item.id}`"
                    :input-value="allowedStocks"
                    :label="item.name"
                    :value="item.id"
                    :disabled="item.disabled"
                    class="ma-0"
                    hide-details
                    multiple
                    @change="updateSelectedItems($event)" />
                </v-list-item>
              </template>
            </v-virtual-scroll>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { GET_STOCKS } from '@/resources/graphql'

export default {
  props: {
    allowedStocks: {
      type: Array,
      default: () => []
    },
    accessAllStock: Boolean
  },
  apollo: {
    stocks: {
      query: GET_STOCKS,
      variables () {
        return {
          page: 1,
          perPage: 1000
        }
      }
    }
  },
  data () {
    return {
      state: 'ready',
      menu: false,
      query: '',
      timeOut: null,
      isTimeout: false,
      stocks: {
        nodes: []
      }
    }
  },
  computed: {
    label () {
      if (this.accessAllStock) {
        return this.$t('administrator.user.field.storage.selectAll')
      }
      let label = ''
      if (this.selectedItems.length) {
        label += this.selectedItems[0].name
        if (this.selectedItems[1]) {
          label += ` (+${ this.selectedItems.length - 1 } others)`
        }
      }
      return label
    },
    selectedItems () {
      return this.stocks.nodes
        .filter((item) => this.allowedStocks.includes(item.id))
    },
    tooltipSelectedItems () {
      return this.selectedItems.map((item) => item.name).join(', ')
    },
    selectItems () {
      return this.stocks.nodes
        .filter((item) => item.name.includes(this.query))
        .map((item) => ({ ...item, disabled: this.accessAllStock }))
    }
  },
  methods: {
    updateSelectedItems (value) {
      this.$emit('update:allowed-stocks', value)
    },
    updateAccessAllStock (value) {
      this.$emit('update:access-all-stock', value)
      let values = this.allowedStocks.slice()
      if (value) {
        values = this.stocks.nodes.map((item) => item.id)
      }
      this.$emit('update:allowed-stocks', values)
    }
  }
}
</script>

<style>
.v-list-item.h-38 {
  min-height: 38px;
}
</style>

<style scoped>

</style>
